import { create } from 'zustand';

// Shell-level UI state shared across the topbar, left nav, and workbench.
//   - navCollapsed: the left nav rail open/closed (persisted; the mockup's
//     220px ↔ 52px collapse).
//   - rail: the right-rail content slot. A route (deal/account workspace,
//     Task I.2/I.3) sets a React node here on mount and clears it on unmount;
//     list views leave it null so the grid renders two columns. Keeps the
//     right rail part of the shell, not the page (TRACON-DESIGN-SYSTEM.md).
//   - bottomBar: WHO OWNS THE PHONE'S BOTTOM BAR. The shell's BottomTabBar
//     renders while the owner is SHELL_BOTTOM_BAR; a page that brings its own
//     bar (the v3 account page's PhoneBar, the Mobile sketch's Next up /
//     Search / Accounts / Money) claims it on mount and releases it on
//     unmount, so one fixed bar sits at the bottom, never two. The release
//     checks the claimant, so an unmount racing a newer claim cannot clear it.

const LS_NAV = 'tracon:nav-collapsed';
export const SHELL_BOTTOM_BAR = 'shell';

function initialNavCollapsed() {
  try {
    return localStorage.getItem(LS_NAV) === '1';
  } catch {
    return false;
  }
}

export const useShellStore = create((set) => ({
  navCollapsed: initialNavCollapsed(),
  toggleNav: () =>
    set((s) => {
      const next = !s.navCollapsed;
      try {
        localStorage.setItem(LS_NAV, next ? '1' : '0');
      } catch {
        /* private mode — non-fatal */
      }
      return { navCollapsed: next };
    }),

  rail: null,
  setRail: (rail) => set({ rail }),
  clearRail: () => set({ rail: null }),

  bottomBar: SHELL_BOTTOM_BAR,
  claimBottomBar: (owner) => set({ bottomBar: owner }),
  releaseBottomBar: (owner) => set((s) => (s.bottomBar === owner ? { bottomBar: SHELL_BOTTOM_BAR } : {})),
}));
